import axios from 'axios';

const API_URL = process.env.REACT_APP_PEGASUS_API_URL;

const bearerHeader = (token) => ({
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

export const loginScreen = async (screen_code) => {
  const res = await axios.post(`${API_URL}/screens/login`, { screen_code });
  return res.data;
};

export const fetchScreenOrders = async (token) => {
  const res = await axios.get(`${API_URL}/screens/orders`, bearerHeader(token));
  return res.data;
};

export const fetchScreenReports = async (token, params = {}) => {
  const res = await axios.get(`${API_URL}/screens/reports`, {
    ...bearerHeader(token),
    params,
  });
  return res.data;
};

export const fetchReportsProducts = async (token, params = {}) => {
  const res = await axios.get(`${API_URL}/reports/products`, {
    ...bearerHeader(token),
    params,
  });
  return res.data;
};

export const fetchReportsOrders = async (token, params = {}) => {
  const res = await axios.get(`${API_URL}/reports/orders`, {
    ...bearerHeader(token),
    params,
  });
  return res.data;
};

export const fetchReportsInventory = async (token, params = {}) => {
  const res = await axios.get(`${API_URL}/reports/inventory`, {
    ...bearerHeader(token),
    params,
  });
  return res.data;
};

export const fetchUserOrders = async (token, username) => {
  const res = await axios.get(`${API_URL}/screens/orders/user/${username}`, bearerHeader(token));
  return res.data;
};

export const finishOrder = async (token, orderId) => {
  const res = await axios.post(`${API_URL}/screens/order/finish/${orderId}`, {}, bearerHeader(token));
  return res.data;
};

export default {
  loginScreen,
  fetchScreenOrders,
  fetchScreenReports,
  fetchReportsProducts,
  fetchReportsOrders,
  fetchReportsInventory,
  fetchUserOrders,
  finishOrder,
};
